// Estados de un agente. Son DOS cosas distintas y conviven:
//
//   CONEXION  (`usuarioVinculoStatus`)  -> el vinculo del agente con el servicio.
//                                          Se muestra y se edita en el listado.
//                                          Valores: A, S, B.
//   OPERATIVO (`rnhAgenteStatus`)       -> la situacion del agente. Los mismos tres
//                                          mas Licencia. Se edita en el detalle.
//
// Las etiquetas y los colores son los mismos para los dos, asi que hay una sola
// tabla y cada conjunto es un subconjunto de codigos. Si un estado cambia de color,
// se toca en un lugar y cambia en los dos lados.
//
// Vive aca y no en la carpeta del ABM porque lo comparten el select de los modales
// (pages/programa-salud/personal/agentes) y la columna de la grilla (consts/titulos-de-tablas).
// Mismo criterio que consts/leyes.
//
// Los colores son explicitos y no nombres de la paleta de MUI (`success`, `warning`...)
// por dos razones: el theme del proyecto solo define `primary`/`secondary`, y el
// `warning` de MUI es naranja, no amarillo. Son tonos suaves de fondo con texto fuerte,
// que es lo que se lee bien en una grilla con filas de 36px.
export const ESTADOS_AGENTE = [
    {
        cod: "A",
        label: "Activo",
        color: { fondo: "#E6F4EA", texto: "#1E7A3C", borde: "#A8DCB8" },
    },
    {
        cod: "B",
        label: "Baja",
        color: { fondo: "#FDECEA", texto: "#B3261E", borde: "#F2B8B5" },
    },
    {
        cod: "S",
        label: "Suspendido",
        color: { fondo: "#FFF6DA", texto: "#8A6100", borde: "#F2D98A" },
    },
    {
        cod: "L",
        label: "Licencia",
        color: { fondo: "#E4F1FB", texto: "#1B5E8C", borde: "#A9CFEA" },
    },
];

// Para un cod que no conocemos: gris neutro. No se oculta el valor, se muestra crudo.
export const COLOR_ESTADO_DESCONOCIDO = {
    fondo: "#EEEEEE",
    texto: "#5F6368",
    borde: "#D0D0D0",
};

// Subconjuntos por tipo de estado. Se derivan de la tabla de arriba para que no
// haya dos listas que mantener sincronizadas.
const codsDe = (...cods) => ESTADOS_AGENTE.filter((e) => cods.includes(e.cod));

/** Vinculo con el servicio: se edita desde el listado. */
export const ESTADOS_CONEXION = codsDe("A", "S", "B");

/** Situacion del agente: agrega Licencia y se edita desde el detalle. */
export const ESTADOS_OPERATIVO = codsDe("A", "S", "B", "L");

const POR_COD = Object.fromEntries(ESTADOS_AGENTE.map((e) => [e.cod, e]));

/** El estado completo (label + color), o `undefined` si el cod no está en la tabla. */
export const estadoAgente = (cod) => POR_COD[cod];

/**
 * Código -> etiqueta legible. Si el código no está en la tabla devuelve el crudo: es
 * preferible ver una "Z" rara y darse cuenta de que falta un estado, a ver la celda
 * vacía y no enterarse.
 */
export const etiquetaEstado = (cod) => POR_COD[cod]?.label ?? (cod ?? "");
